import darkLoadingDots from '@rhg/../public/_n/animations/loading_dots_dark.json';

export default darkLoadingDots;
